import { GetDeleteCityData, CreateCityData ,UpdateCityData,CityData,ReturnUpdateDelete,UpdateCityFavoritesData,GetAllCitiesData, CloneCitySettingsData, InitializeCityData, GetCityStatsData} from "@/types";
import { PostRequest ,PostRequestFormData} from "./requests";

export const getByCityID = async (data: GetDeleteCityData): Promise<CityData> => {
    try {
        return await PostRequest<CityData>("/api/city/get", data);
    } catch (error) {
        console.log('Error in getByCityID:', error);
        throw error;
    }
}

export const createCity = async (data: CreateCityData) => {
    try {
        return await PostRequestFormData("/api/city/create", data);
    } catch (error) {
        console.log('Error in createCity:', error);
        throw error;
    }
}

export const getCity = async (data: GetDeleteCityData): Promise<CityData> => {
    try {
        return await PostRequest<CityData>("/api/city/get", data);
    } catch (error) {
        console.log('Error in getCity:', error);
        throw error;
    }
}
export const getAllCities = async (data?: GetAllCitiesData): Promise<CityData[]> => {
    try {
        return await PostRequest<CityData[]>("/api/city/get_all", data || {});
    } catch (error) {
        console.log('Error in getAllCities:', error);
        throw error;
    }
}

export const updateCity = async (data: UpdateCityData): Promise<ReturnUpdateDelete> => {
    try {
        return await PostRequestFormData("/api/city/update", data);
    } catch (error) {
        console.log('Error in updateCity:', error);
        throw error;
    }
}

export const updateCityFavorites = async (data: UpdateCityFavoritesData): Promise<ReturnUpdateDelete> => {
    try {
        return await PostRequest("/api/city/update_city_favorites", data);
    } catch (error) {
        console.log('Error in updateCityFavorites:', error);
        throw error;
    }
}

export const deleteCity = async (data: GetDeleteCityData): Promise<ReturnUpdateDelete> => {
    try {
       return await PostRequest<ReturnUpdateDelete>("/api/city/delete", data);
    } catch (error) {
        console.log('Error in deleteCity:', error);
        throw error;
    }
}

export const cloneCitySettings = async (data: CloneCitySettingsData): Promise<ReturnUpdateDelete> => {
    try {
        return await PostRequest<ReturnUpdateDelete>("/api/city/clone_settings", data);
    } catch (error) {
        console.log('Error in cloneCitySettings:', error);
        throw error;
    }
}

export const initializeCity = async (data: InitializeCityData): Promise<ReturnUpdateDelete> => {
    try {
        return await PostRequest<ReturnUpdateDelete>("/api/city/initialize", data);
    } catch (error) {
        console.log('Error in initializeCity:', error);
        throw error;
    }
}

export const getCityStats = async (data?: GetCityStatsData): Promise<CityData | CityData[]> => {
    try {
        return await PostRequest<CityData | CityData[]>("/api/city/get_stats", data || {});
    } catch (error) {
        console.log('Error in getCityStats:', error);
        throw error;
    }
}
